import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollItemDetailSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/payroll-items/$payrollItemId/')({
  validateSearch: zodValidator(PayrollItemDetailSearchSchema)
});